import styled from 'styled-components';

const CardTitleWrapper = styled.div`
  padding: 6px 13px 12px 8px;
`;

export default CardTitleWrapper;
